import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';

const api = axios.create({
  baseURL: `${API_URL}/api`,
  withCredentials: true, // send httpOnly refresh_token cookie
  headers: { 'Content-Type': 'application/json' },
});

// Attach access token from localStorage to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// On 401 — attempt a silent token refresh, then retry once
let refreshing = null; // shared promise so concurrent 401s don't fire multiple refreshes

api.interceptors.response.use(
  (res) => res,
  async (err) => {
    const original = err.config;

    if (err.response?.status === 401 && !original._retry) {
      original._retry = true;

      if (!refreshing) {
        refreshing = axios
          .post(`${API_URL}/api/auth/refresh`, {}, { withCredentials: true })
          .then((r) => {
            localStorage.setItem('access_token', r.data.data.accessToken);
            return r.data.data.accessToken;
          })
          .catch(() => {
            localStorage.removeItem('access_token');
            localStorage.removeItem('auth_user');
            localStorage.removeItem('auth_tenant');
            window.dispatchEvent(new Event('auth:logout'));
          })
          .finally(() => { refreshing = null; });
      }

      const newToken = await refreshing;
      if (newToken) {
        original.headers.Authorization = `Bearer ${newToken}`;
        return api(original);
      }
    }

    return Promise.reject(err);
  }
);

export default api;
